import React from "react";
import PropTypes from "prop-types";
import Badge from "theme/components/badges/Badge";
import GreyBadge from "theme/components/badges/styledBadges/GreyBadge";
import BlueBadge from "theme/components/badges/styledBadges/BlueBadge";
import YellowBadge from "theme/components/badges/styledBadges/YellowBadge";

const badges = {
    grey: GreyBadge,
    blue: BlueBadge,
    yellow: YellowBadge,
};

const ThemeBadge = ({ badgeTheme, ...rest }) => {
    // We decide badge by theme, but if the theme badge does not exist, we take the first in the list.
    // This is to ensure that the badge does not crash the content.
    const RenderBadges = badges[badgeTheme] || badges[Object.keys(badges)[0]];
    return <RenderBadges {...rest} />;
};

ThemeBadge.propTypes = {
    ...Badge.propTypes,
    badgeTheme: PropTypes.oneOf(Object.keys(badges)),
};

ThemeBadge.defaultProps = {
    ...Badge.defaultProps,
    badgeTheme: Object.keys(badges)[0],
};

export default ThemeBadge;
